import React from 'react';
import { useQuery } from 'react-query';
import axios from 'axios';
import { useAuthStore } from '../stores/authStore';
import { BookOpen, Award, Clock, TrendingUp } from 'lucide-react';
import { Link } from 'react-router-dom';

const fetchEnrollments = async (userId) => {
  const res = await axios.get(`/enrollments/user/${userId}`);
  return res.data;
};

export default function DashboardPage() {
  const { user } = useAuthStore();
  const { data, isLoading } = useQuery(
    ['enrollments', user?.id],
    () => fetchEnrollments(user.id),
    { enabled: !!user } // รอให้มี user ก่อน
  );

  const enrollments = data?.data || [];

  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-2">แดชบอร์ด</h1>
      <p className="text-gray-500 mb-8">สวัสดี, {user?.firstName}!</p>

      {/* Stats */}
      <div className="grid md:grid-cols-4 gap-4 mb-8">
        <StatCard icon={<BookOpen size={24} />} label="คอร์สที่ลงทะเบียน" value={enrollments.length} />
        <StatCard icon={<Award size={24} />} label="คอร์สที่จบแล้ว" value={enrollments.filter(e => e.status === 'completed').length} />
        <StatCard icon={<Clock size={24} />} label="ชั่วโมงเรียน" value="12" />
        <StatCard icon={<TrendingUp size={24} />} label="คะแนนเฉลี่ย" value="85%" />
      </div>

      {/* My Courses */}
      <h2 className="text-xl font-bold mb-4">คอร์สของฉัน</h2>
      {isLoading ? (
        <div className="text-center py-8">กำลังโหลด...</div>
      ) : enrollments.length === 0 ? (
        <div className="bg-gray-50 rounded-xl p-8 text-center">
          <p className="text-gray-500 mb-4">ยังไม่ได้ลงทะเบียนคอร์ส</p>
          <Link to="/courses" className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition">
            ค้นหาคอร์ส
          </Link>
        </div>
      ) : (
        <div className="space-y-4">
          {enrollments.map(e => (
            <div key={e.id} className="bg-white rounded-xl p-4 shadow-sm border flex items-center gap-4">
              <div className="w-16 h-16 bg-gray-200 rounded-lg flex items-center justify-center">
                <BookOpen className="text-gray-400" />
              </div>
              <div className="flex-grow">
                <h3 className="font-bold">{e.course_title}</h3>
                <p className="text-sm text-gray-500">ลงทะเบียน: {new Date(e.enrolled_at).toLocaleDateString('th-TH')}</p>
                <div className="mt-2">
                  <div className="w-full bg-gray-200 rounded-full h-2">
                    <div className="bg-blue-600 h-2 rounded-full transition-all" style={{ width: `${e.progress_percent}%` }} />
                  </div>
                  <p className="text-xs text-gray-500 mt-1">ความคืบหน้า {e.progress_percent}%</p>
                </div>
              </div>
              <Link to={`/courses/${e.course_id}/learn`} className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition">
                เรียนต่อ
              </Link>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function StatCard({ icon, label, value }) {
  return (
    <div className="bg-white rounded-xl p-6 shadow-sm border">
      <div className="text-blue-600 mb-3">{icon}</div>
      <div className="text-2xl font-bold">{value}</div>
      <div className="text-sm text-gray-500">{label}</div>
    </div>
  );
}
